// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2Uojn","content":"styles_content__-soGQ","row":"styles_row__3cytl","footer":"styles_footer__2bpHZ","phraseLength":"styles_phraseLength__1TDWF"};